export const isHostedBundle = () => typeof __AI_INTERVIEW_HOSTED_BUNDLE__ !== 'undefined' && __AI_INTERVIEW_HOSTED_BUNDLE__ === true;
